import { blobToDataURL } from './previewImage';

/**
 * A ready-made buddy (Zippy / Benny / Pip) picked in the website onboarding
 * becomes the child's first character exactly the way the funnel keeps a
 * preset friend (FunnelAuthPage: choosePresetFriend + saveHeldCharacter):
 * the friend's still, sized to 768px and flattened, uploaded through
 * apiClient.saveFunnelCharacter under the child's name.
 *
 * Onboarding only runs for brand-new accounts, so this is always their first
 * character: the funnel's "members-only refusal, save after payment" case
 * cannot arise here and is deliberately not handled.
 */

// Same helper the funnel uses to turn its held preview back into an upload
export const dataURLtoBlob = (dataUrl) => {
  const [meta, b64] = dataUrl.split(',');
  const mime = meta.match(/data:(.*?);/)?.[1] || 'image/jpeg';
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
};

export const saveBuddyCharacter = async (apiClient, { userId, name, src }) => {
  const response = await fetch(src);
  if (!response.ok) throw new Error(`Could not load the buddy image (${response.status})`);
  // 768 is the cap the funnel applies to a preset friend (and to a generated
  // preview), so the character image is the same size either way
  const dataUrl = await blobToDataURL(await response.blob(), 768);
  return apiClient.saveFunnelCharacter({ userId, name, animatedImage: dataURLtoBlob(dataUrl) });
};
